// extracted by mini-css-extract-plugin
export default {"select":"dcc_form-select","textInput":"dcc_form-textInput","checkbox":"dcc_form-checkbox","radio":"dcc_form-radio","range":"dcc_form-range"};